/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Genius_Agent_Message_StatusInputs */

const tr_landing_genius_agent_message_status = /** @type {(inputs: Landing_Genius_Agent_Message_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trendyol · 'Kargo ne zaman?' · yanıt hazır. Gönder?`)
};

const en_landing_genius_agent_message_status = /** @type {(inputs: Landing_Genius_Agent_Message_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trendyol · 'When will my order ship?' · reply ready. Send?`)
};

const de_landing_genius_agent_message_status = /** @type {(inputs: Landing_Genius_Agent_Message_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trendyol · „Wann kommt meine Bestellung?“ · Antwort bereit. Senden?`)
};

const ru_landing_genius_agent_message_status = /** @type {(inputs: Landing_Genius_Agent_Message_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trendyol · «Когда придет заказ?» · ответ готов. Отправить?`)
};

/**
* | output |
* | --- |
* | "Trendyol · 'When will my order ship?' · reply ready. Send?" |
*
* @param {Landing_Genius_Agent_Message_StatusInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_genius_agent_message_status = /** @type {((inputs?: Landing_Genius_Agent_Message_StatusInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Genius_Agent_Message_StatusInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_genius_agent_message_status(inputs)
	if (locale === "de") return de_landing_genius_agent_message_status(inputs)
	if (locale === "ru") return ru_landing_genius_agent_message_status(inputs)
	return tr_landing_genius_agent_message_status(inputs)
});